import { render } from "./SideBar.vue?vue&type=template&id=97932b56"
import script from "./SideBar.vue?vue&type=script&lang=js"
export * from "./SideBar.vue?vue&type=script&lang=js"

import "./SideBar.vue?vue&type=style&index=0&id=97932b56&lang=css"

import exportComponent from "C:\\yasukochi\\Work\\11_Marron\\00_Working\\Jarvis\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__